const COMBINED_IMAGES = [
    // From IMAGES
    {
        image: require("./preferences/Gluten-Free.svg").default,
        name: "Gluten-Free.svg"
    },
    {
        image: require("./preferences/dairy-free.svg").default,
        name: "dairy-free.svg"
    },
    {
        image: require("./preferences/vegan.svg").default,
        name: "vegan.svg"
    },
    {
        image: require("./preferences/allery-1.svg").default,
        name: "allery-1.svg"
    },
    {
        image: require("./preferences/allery-2.svg").default,
        name: "allery-2.svg"
    },
    {
        image: require("./preferences/allery-3.svg").default,
        name: "allery-3.svg"
    },
    {
        image: require("./preferences/mild.svg").default,
        name: "mild.svg"
    },
    {
        image: require("./preferences/nut.svg").default,
        name: "nut.svg"
    },
    {
        image: require("./preferences/mustard.svg").default,
        name: "mustard.svg"
    },
    {
        image: require("./preferences/peanut.svg").default,
        name: "peanut.svg"
    },
    {
        image: require("./preferences/soy.svg").default,
        name: "soy.svg"
    },
    {
        image: require("./preferences/sulfite.svg").default,
        name: "sulfite.svg"
    },
    {
        image: require("./preferences/nut-2.svg").default,
        name: "nut-2.svg"
    },
    {
        image: require("./preferences/celery.svg").default,
        name: "celery.svg"
    },
    {
        image: require("./preferences/fish.svg").default,
        name: "fish.svg"
    },
    {
        image: require("./preferences/raw.svg").default,
        name: "raw.svg"
    },
    // From IMAGES2 (excluding duplicates)
    {
        image: require('./most-selling.svg').default,
        name: 'most-selling.svg'
    },
    {
        image: require('./trending.svg').default,
        name: 'trending.svg'
    },
    {
        image: require('./chef-choice.svg').default,
        name: 'chef-choice.svg'
    },
    {
        image: require('./Megaphone.svg').default,
        name: 'Megaphone.svg'
    },
    {
        image: require('./vegetarian.svg').default,
        name: 'vegetarian.svg'
    },
    {
        image: require('./spicy.svg').default,
        name: 'spicy.svg'
    },
    {
        image: require('./allery-4.svg').default,
        name: 'allery-4.svg'
    },
    {
        image: require('./allery-5.svg').default,
        name: 'allery-5.svg'
    },
    {
        image: require('./allery-6.svg').default,
        name: 'allery-6.svg'
    },
    {
        image: require('./dairy.svg').default,
        name: 'dairy.svg'
    },
    {
        image: require('./egg3.svg').default,
        name: 'egg3.svg'
    },
    {
        image: require('./gluten.svg').default,
        name: 'gluten.svg'
    }
];

export default COMBINED_IMAGES;